import BootstrapModal from "../../components/BootstrapModal";
import {Formik, Form, Field} from 'formik'
import TextField from "../../components/TextField";
import * as Yup from 'yup'
import PMSCheckBox from "../../components/PMSCheckBox";
import FormSelect from "../../components/FormSelect";
import {ProgressSpinner} from "primereact/progressspinner";
import { Hidden } from "@mui/material";

const SkillMatrixForm = ({modal, roleWiseMatrixID,userRoleID,matrixTitle,
weight,rca,active, isLoading,setactiveUserRoleNames, onSubmit, onHide}) => {
    const validation = Yup.object({
        userRoleID:Yup.number().positive('please select role'),
        matrixTitle:  Yup.string().required('This field is required'),
        weight: Yup.number().positive('Weight is required'),
        rca: Yup.number().positive('RCA is required'),
        
    })
    return (<>
        <BootstrapModal headerText="Add Skill Matrix" size={40} visible={modal} onHide={onHide}>
            <Formik
                validationSchema={validation}
                initialValues={{
                    roleWiseMatrixID: roleWiseMatrixID,                    
                    userRoleID:userRoleID,				    
                    matrixTitle: matrixTitle,
				    weight:weight,
                    rca:rca,
                    active: active}}
                onSubmit={onSubmit}>
                {formik =>

                    (<>
                        <Form>
                            <Field type="hidden" name="roleWiseMatrixID"/>                                                    
                            <FormSelect id="userRoleID" name="userRoleID" options={setactiveUserRoleNames}/>                                                        
                            <TextField label={'Matrix Title'} type="text" name="matrixTitle"/>							                            
                            <TextField label={'Weight'} type="text" name="weight"/> 
                            <TextField label={'RCA'} type="text" name="rca"/> 
                            <PMSCheckBox label={'Active'} name={'active'} id={'active'}/>
                            {isLoading ? <ProgressSpinner style={ {height:30,width:30} }/> : <button type="submit" className="btn btn-primary">{roleWiseMatrixID === 0 ? 'Save' : 'Update'} </button>}

                        </Form>
                    </>)}

            </Formik>
        </BootstrapModal>
    </>)
}

export default SkillMatrixForm